import React from 'react'
import Carousel from '@brainhubeu/react-carousel';
import '@brainhubeu/react-carousel/lib/style.css';

import Container from '../../layout/container'
import { KitStyle, KitGroup, KitItem, KitBannerContent, KitBannerContentText, KitBannerContentTextItem, KitTitle, KitText, KitBanner } from './style'

import Kit1 from '../../assets/kits/4.png'
import Kit2 from '../../assets/kits/5.png'
import Kit3 from '../../assets/kits/kit3-2.png'
import Img40off from '../../assets/kits/oboticario-offf.png'

const items = [
  {
    id: 1,
    title: '1er ciclo',
    listPrice: '83.880',
    price: '159.900',
    total: '75.920',
    text: '¡Recibirás lo mejor de nuestro portafolio para empezar tu negocio! Conquista a tus clientes con nuestros productos héroes.',
    img: Kit1
  },
  {
    id: 2,
    title: '2do ciclo',
    listPrice: '64.850',
    price: '134.700',
    total: '69.850',
    text: 'Habrás alcanzado una nueva etapa de tu negocio y te seguiremos enamorando de nuestras fragancias y productos favoritos.',
    img: Kit2
  },
  {
    id: 3,
    title: '3er ciclo',
    listPrice: '79.920',
    price: '199.800',
    total: '119.880',
    text: 'Aún tendrás mucho más que conocer y ofrecer a tus clientes ¡Las ganancias para ti no paran!',
    img: Kit3
  }
]

export default function Kit() {
  return (
    <KitStyle>
      <Container>
        <h2>Kit de inicio</h2>

        <KitGroup>
          {items.map(({ id, title, listPrice, price, total, text, img }) =>
            <Item
              key={id}
              id={id}
              title={title}
              listPrice={listPrice}
              price={price}
              total={total}
              text={text}
              img={img}
            />
          )}
        </KitGroup>

        <Carousel dots lazyload infinite>
          {items.map(({ id, title, listPrice, price, total, text, img }) =>
            <Item
              key={id}
              id={id}
              title={title}
              listPrice={listPrice}
              price={price}
              total={total}
              text={text}
              img={img}
            />
          )}
        </Carousel>

        <KitBanner>
          <KitTitle>4to ciclo</KitTitle>
          <KitBannerContent>
            <img src={Img40off} />
            <KitBannerContentText>
              <KitBannerContentTextItem primary>DE COMISIÓN</KitBannerContentTextItem>
              <KitBannerContentTextItem>EN TODO TU PEDIDO</KitBannerContentTextItem>
            </KitBannerContentText>
          </KitBannerContent>
          <KitText>
            Al llegar aquí sabremos el compromiso que has dedicado a tu negocio y te recompensamos por superar los primeros pasos sin rendirte y completar cada uno de los anteriores pasos.
          </KitText>
        </KitBanner>
      </Container>
    </KitStyle>
  )
}

const Item = ({ title, listPrice, price, total, text, img }) => {
  return (
    <KitItem>
      <KitTitle>{title}</KitTitle>
      <img src={img} alt={title} />
      <table>
        <tbody>
          <tr>
            <td>Tu pagas:</td>
            <td>$ {listPrice}</td>
          </tr>
          <tr>
            <td>Precio catálogo:</td>
            <td>$ {price}</td>
          </tr>
          <tr className="highlight">
            <td>Tu ganancia:</td>
            <td>$ {total}</td>
          </tr>
        </tbody>
      </table>
      <KitText>{text}</KitText>
    </KitItem>
  )
}
